import { FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { SocialLinksContainer, SocialLink } from './SocialLinks.styles';
import { useSiteSettings } from '../../../hooks/useSiteSettings';

export const SocialLinks = () => {
  const { settings } = useSiteSettings();
  
  if (!settings?.socialMedia) return null;
  
  const { facebook, instagram, whatsapp } = settings.socialMedia;
  
  return (
    <SocialLinksContainer>
      {facebook && (
        <SocialLink 
          href={facebook} 
          className="facebook"
          aria-label="Facebook"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebook />
        </SocialLink>
      )}
      {instagram && (
        <SocialLink 
          href={instagram} 
          className="instagram"
          aria-label="Instagram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram />
        </SocialLink>
      )}
    </SocialLinksContainer>
  );
}; 